import {type} from '../../utils/types';
import {Action} from '@ngrx/store';
import {AttributeMetadataModel, DataAccessRequestModel} from '../../model/integration-models';
import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';
import {InstitutionsVendorListModel} from '../../model/institutional-model';
import {SchoolYearRolloverModel} from '@app/core/model/rollover-model';
import {ICategory} from '@app/core/comp/filtering/filter';
import {ApplicationGalleryModel} from '@app/views/admin/application-settings/models/application-gallery.model';

export const IntegrationActionTypes = {
    INTEGRATION_GET_DEFAULT: type('[integration] Getting default integration'),
    INTEGRATION_GET_DEFAULT_SUCCESS: type('[integration] Getting default integration is success'),
    INTEGRATION_GET_DEFAULT_FAILED: type('[integration] Getting default integration is failed'),
    GET_DEFAULT_SCHEMA: type('[integration] Getting default schema'),
    GET_DEFAULT_SCHEMA_SUCCESS: type('[integration] Getting default schema is success'),
    GET_DEFAULT_SCHEMA_FAILED: type('[integration] Getting default schema is failed'),
    GET_DEFAULT_CATEGORIES: type('[integration] Getting default categories'),
    GET_DEFAULT_CATEGORIES_SUCCESS: type('[integration] Getting default categories is success'),
    GET_DEFAULT_CATEGORIES_FAILED: type('[integration] Getting default categories is failed'),
    GET_PENDING_REQUESTS: type('[integration] Getting pending requests'),
    GET_PENDING_REQUESTS_SUCCESS: type('[integration] Getting pending requests is success'),
    GET_PENDING_REQUESTS_FAILED: type('[integration] Getting pending requests is failed'),
    GET_PROVIDER_APPLICATIONS: type('[integration] Getting provider applications'),
    GET_PROVIDER_APPLICATIONS_SUCCESS: type('[integration] Getting provider applications is success'),
    GET_PROVIDER_APPLICATIONS_FAILED: type('[integration] Getting provider applications is failed'),
    SET_DELETING_APPLICATIONS: type('[integration] Setting deleting applications'),
    GET_VENDOR_INSTITUTIONS: type('[integration] Getting vendor institutions'),
    GET_VENDOR_INSTITUTIONS_SUCCESS: type('[integration] Getting vendor institutions is success'),
    GET_VENDOR_INSTITUTIONS_FAILED: type('[integration] Getting vendor institutions is failed'),
    GET_ALL_VENDOR_APPLICATIONS: type('[integration] Getting all vendor applications'),
    GET_ALL_VENDOR_APPLICATIONS_SUCCESS: type('[integration] Getting all vendor applications is success'),
    GET_ALL_VENDOR_APPLICATIONS_FAILED: type('[integration] Getting all vendor applications is failed'),
    UPDATE_APP_IN_ALL_VENDOR_APPLICATIONS: type('[integration] Update application in all vendor applications'),
    GET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS: type('[integration] Getting School Year data rollover settings'),
    SET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS_SUCCESS: type('[integration] Set School Year data rollover setting'),
    GET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS_FAILED: type('[integration] Getting School Year data rollover setting is failed'),
    UPDATE_VENDOR_CURRENT_APP: type('[integration] Update Vendor Current App'),
    UPDATE_VENDOR_CURRENT_APP_SUCCESS: type('[integration] Update Vendor Current App is success'),
    UPDATE_VENDOR_CURRENT_APP_FAILED: type('[integration] Update Vendor Current App is failed'),
    UPDATE_VENDOR_CURRENT_APP_UNNECESSARY: type('[integration] Update Vendor Current App is unnecessary'),
    INTEGRATION_CLEAR_STATE: type('[integration] Clear state'),
    INTEGRATION_CLEAR_SESSION_STORED_DATA: type('[integration] Clear data stored for use during the session')
};

export class IntegrationGettingDefaultAction implements Action {
    readonly type: string = IntegrationActionTypes.INTEGRATION_GET_DEFAULT;
    constructor(public payload: {applicationId: string}) {}
}

export class IntegrationGettingDefaultSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.INTEGRATION_GET_DEFAULT_SUCCESS;
    constructor(public payload?: {integration: any}) {}
}

export class IntegrationGettingDefaultFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.INTEGRATION_GET_DEFAULT_FAILED;
    constructor(public payload?: any) {}
}

export class GetDefaultSchemaAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_SCHEMA;
    constructor(public payload?: any) {}
}

export class GetDefaultSchemaSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_SCHEMA_SUCCESS;
    constructor(public payload: {attributeMetadata: AttributeMetadataModel[]}) {}
}

export class GetDefaultSchemaFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_SCHEMA_FAILED;
    constructor(public payload?: any) {}
}

export class GetDefaultCategoriesAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_CATEGORIES;
    constructor(public payload?: any) {}
}

export class GetDefaultCategoriesSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_CATEGORIES_SUCCESS;
    constructor(public payload: ICategory[]) {}
}

export class GetDefaultCategoriesFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_DEFAULT_CATEGORIES_FAILED;
    constructor(public payload?: any) {}
}

export class GetPendingRequestsAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PENDING_REQUESTS;
    constructor(public payload?: {currentAppId: string}) {}
}

export class GetPendingRequestsSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PENDING_REQUESTS_SUCCESS;
    constructor(public payload: {allPendingRequests: DataAccessRequestModel[]; pendingRequests: DataAccessRequestModel[]}) {}
}

export class GetPendingRequestsFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PENDING_REQUESTS_FAILED;
    constructor(public payload?: any) {}
}

export class GetProviderApplicationsAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PROVIDER_APPLICATIONS;
    constructor(public payload?: {orgGuid: string}) {}
}

export class GetProviderApplicationsSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PROVIDER_APPLICATIONS_SUCCESS;
    constructor(public payload: {applications: ApplicationProviderListModel[]}) {}
}

export class SetDeletingApplicationsAction implements Action {
    readonly type: string = IntegrationActionTypes.SET_DELETING_APPLICATIONS;
    constructor(public payload: ApplicationProviderListModel[]) {}
}

export class GetProviderApplicationsFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_PROVIDER_APPLICATIONS_FAILED;
    constructor(public payload?: {error: Error}) {}
}

export class GetVendorInstitutionsAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_VENDOR_INSTITUTIONS;
    constructor(public payload: {currentAppId: string}) {}
}

export class GetVendorInstitutionsSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_VENDOR_INSTITUTIONS_SUCCESS;
    constructor(public payload: {institutions: InstitutionsVendorListModel[]}) {}
}

export class GetVendorInstitutionsFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_VENDOR_INSTITUTIONS_FAILED;
    constructor(public payload?: {error: Error}) {}
}

export class GetAllVendorApplicationsAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_ALL_VENDOR_APPLICATIONS;
    constructor(public payload: any) {}
}

export class GetAllVendorApplicationsSuccessAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_ALL_VENDOR_APPLICATIONS_SUCCESS;
    constructor(public payload: {allVendorApplications: ApplicationGalleryModel[]}) {}
}

export class GetAllVendorApplicationsFailedAction implements Action {
    readonly type: string = IntegrationActionTypes.GET_ALL_VENDOR_APPLICATIONS_FAILED;
    constructor(public payload?: {error: Error}) {}
}

export class UpdateAppInAllVendorApplicationsAction implements Action {
    readonly type: string = IntegrationActionTypes.UPDATE_APP_IN_ALL_VENDOR_APPLICATIONS;
    constructor(public payload: ApplicationGalleryModel) {}
}

export class GetSchoolYearRolloverSettingsAction implements Action {
    readonly type = IntegrationActionTypes.GET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS;
    constructor(public payload: string) {}
}

export class SetSchoolYearRolloverSettingsAction implements Action {
    readonly type = IntegrationActionTypes.SET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS_SUCCESS;
    constructor(public payload: SchoolYearRolloverModel[]) {}
}

export class GetSchoolYearRolloverSettingsFailedAction implements Action {
    readonly type = IntegrationActionTypes.GET_SCHOOL_YEAR_DATA_ROLLOVER_SETTINGS_FAILED;
    constructor(public payload?: {error: Error}) {}
}

export class UpdateVendorCurrentAppAction implements Action {
    readonly type: string = IntegrationActionTypes.UPDATE_VENDOR_CURRENT_APP;
    constructor(public payload?: {currentAppId: string}) {}
}

export class UpdateVendorCurrentAppActionSuccess implements Action {
    readonly type: string = IntegrationActionTypes.UPDATE_VENDOR_CURRENT_APP_SUCCESS;
    constructor(public payload?: {currentAppId: string}) {}
}
export class UpdateVendorCurrentAppActionFailed implements Action {
    readonly type: string = IntegrationActionTypes.UPDATE_VENDOR_CURRENT_APP_FAILED;
    constructor(public payload?: {error: Error}) {}
}
export class UpdateVendorCurrentAppActionUnnecessary implements Action {
    readonly type: string = IntegrationActionTypes.UPDATE_VENDOR_CURRENT_APP_UNNECESSARY;
    constructor(public payload?: {currentAppId: string}) {}
}

export class IntegrationClearState implements Action {
    readonly type: string = IntegrationActionTypes.INTEGRATION_CLEAR_STATE;
    constructor(public payload?: any) {}
}

export class IntegrationClearSessionStoredData implements Action {
    readonly type: string = IntegrationActionTypes.INTEGRATION_CLEAR_SESSION_STORED_DATA;
    constructor(public payload?: any) {}
}

export type Actions =
    IntegrationGettingDefaultAction
    | IntegrationGettingDefaultSuccessAction
    | IntegrationGettingDefaultFailedAction
    | GetDefaultSchemaAction
    | GetDefaultSchemaSuccessAction
    | GetDefaultSchemaFailedAction
    | GetPendingRequestsAction
    | GetPendingRequestsSuccessAction
    | GetPendingRequestsFailedAction
    | GetProviderApplicationsAction
    | GetProviderApplicationsSuccessAction
    | GetProviderApplicationsFailedAction
    | SetDeletingApplicationsAction
    | GetVendorInstitutionsAction
    | GetVendorInstitutionsSuccessAction
    | GetVendorInstitutionsFailedAction
    | GetAllVendorApplicationsAction
    | GetAllVendorApplicationsSuccessAction
    | GetAllVendorApplicationsFailedAction
    | UpdateAppInAllVendorApplicationsAction
    | GetSchoolYearRolloverSettingsAction
    | SetSchoolYearRolloverSettingsAction
    | GetSchoolYearRolloverSettingsFailedAction
    | UpdateVendorCurrentAppAction
    | UpdateVendorCurrentAppActionSuccess
    | UpdateVendorCurrentAppActionUnnecessary
    | UpdateVendorCurrentAppActionFailed
    | IntegrationClearState
    | IntegrationClearSessionStoredData;
